









import AppText from '@berlin-front/common/components/elements/AppText';
import { defineComponent, toRefs, PropType, computed } from '@vue/composition-api';
import { useContext } from '@berlin-front/common/composables/context';
import { ThemeContext } from '@berlin-front/common/services/ThemeContext';
import { useComputedProgress, useHeight, HEIGHT_TYPE, HeightType } from './composable';

/**
 * ## プログレスバー。
 *
 * 顧客期待値を下げないため、処理が進んでると見せかけるために利用する進捗。
 */
export default defineComponent({
  name: 'AppProgressBar',
  components: {
    AppText,
  },

  props: {
    /**
     * 高さ
     * small｜middle
     */
    heightSize: {
      type: String as PropType<HeightType>,
      default: HEIGHT_TYPE.MIDDLE,
    },

    /**
     * 進捗。
     * 0~1の範囲で入力し、1が完了状態。
     */
    progress: {
      type: Number,
      required: true,
    },

    /**
     * 角丸にするかしないか。
     */
    rounded: {
      type: Boolean,
      default: false,
    },

    /**
     * テキスト（「--%」）をつけるかつけないか。
     */
    withText: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const { progress, heightSize } = toRefs(props);
    const { progressTimes100, progressRounded } = useComputedProgress(progress);
    const { themeParameter } = useContext(ThemeContext);
    const primaryColor = computed(() => themeParameter.value.primaryColor);
    const height = useHeight(heightSize);
    return {
      className: 'AppProgressBar',
      height,
      primaryColor,
      progressRounded,
      progressTimes100,
    };
  },
});
